import React, { useRef, useEffect, useState } from "react";
import { useAuth } from "../../../base/context/authcontext";
import { getWithAuth } from "../../../api/api";
import { API_URLS } from "../../../api/apiConfig";
import { useAdminUsersListContext } from "../adminUsersListContext";
import AutoDismissAlert from "../../../components/autoDismiss";
import ModalNewUser from "../components/modalNewUser";
import ModalChangeUserProperties from "../components/modalChangeUserProperties";
import ModalChangeUserRole from "../components/modalChangeUserRole";
import ModalDeactivateUser from "../components/modalDeactivateUser";

const AdminUsersListPage = () => {
  const usersListontext = useAdminUsersListContext();
  const { authData, getSessionUser } = useAuth();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!authData?.user_data) getSessionUser().catch(() => {});
  }, []);

  // 🔹 ahora fuera del useEffect para reutilizarla
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const data = await getWithAuth(API_URLS.GET_USERS);
      setUsers(data.data);
    } catch (error) {
      usersListontext.setMessage(
        "Ha ocurrido un error conectando con el servidor"
      );
      usersListontext.setAlertType("danger");
      usersListontext.openAlertHeader();
      console.error("Error getting users:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const meEmail = authData?.user_data?.email || null;

  return (
    <>
      <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar">
          <div
            id="kt_app_toolbar_container"
            className="app-container container-fluid d-flex flex-stack"
          >
            <div className="page-title d-flex flex-column justify-content-center me-3 mb-6 mb-lg-0">
              <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center me-3 mb-3 my-0">
                Admin - Usuarios
              </h1>
            </div>
          </div>
        </div>

        <div id="kt_app_content" className="app-content flex-column-fluid">
          <div
            id="kt_app_content_container"
            className="app-container container-fluid"
          >
            {usersListontext.showAlertHeader && (
              <div className="">
                <AutoDismissAlert
                  message={usersListontext.message}
                  alertType={usersListontext.alertType}
                  onClose={usersListontext.closeAlertHeader}
                />
              </div>
            )}
            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100vh" }}
              >
                <div
                  className="spinner-grow text-color-verde-wofyrooms"
                  style={{ width: "5rem", height: "5em" }}
                  role="status"
                ></div>
              </div>
            ) : (
              <>
                <div className="card mb-5 mb-xxl-10">
                  <div className="card-header border-0 pt-6">
                    <div className="card-title">
                      <h3>Usuarios de Propiedades</h3>
                    </div>
                    <div className="card-toolbar">
                      <div
                        className="d-flex justify-content-end"
                        data-kt-user-table-toolbar="base"
                      >
                        <button
                          onClick={() => usersListontext.openNewUserModal()}
                          className="btn btn-sm btn-primary mx-2"
                        >
                          <i className="icon-in-button-color ki-outline ki-plus"></i>
                          Nuevo usuario
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="card-body py-10">
                    <div
                      id="kt_table_users_wrapper"
                      className="dataTables_wrapper dt-bootstrap4 no-footer"
                    >
                      <div className="table-responsive">
                        <table
                          className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"
                          id="kt_table_users"
                        >
                          <thead>
                            <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                              <th
                                className="min-w-125px sorting"
                                tabIndex="0"
                                aria-controls="kt_table_users"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="User: activate to sort column ascending"
                              >
                                Nombre
                              </th>
                              <th
                                className="min-w-125px sorting"
                                tabIndex="0"
                                aria-controls="kt_table_users"
                                rowSpan="1"
                                colSpan="1"
                              >
                                Apellido
                              </th>
                              <th
                                className="min-w-125px sorting"
                                tabIndex="0"
                                aria-controls="kt_table_users"
                                rowSpan="1"
                                colSpan="1"
                              >
                                Email
                              </th>
                              <th
                                className="min-w-125px sorting"
                                tabIndex="0"
                                aria-controls="kt_table_users"
                                rowSpan="1"
                                colSpan="1"
                              >
                                Número de propiedades
                              </th>
                              <th
                                className="min-w-125px sorting"
                                tabIndex="0"
                                aria-controls="kt_table_users"
                                rowSpan="1"
                                colSpan="1"
                              >
                                Rol
                              </th>
                              <th className="min-w-125px">Acciones</th>
                            </tr>
                          </thead>
                          <tbody className="text-gray-600 fw-semibold">
                            {users.map((user, index) => {
                              const isSelf =
                                !!meEmail && user.email === meEmail;
                              return (
                                <tr
                                  key={index}
                                  className={isSelf ? "table-row-self" : ""}
                                >
                                  <td>{user.name}</td>
                                  <td>{user.last_name}</td>
                                  <td>
                                    {user.email}
                                    {isSelf && (
                                      <span className="ms-2 badge badge-light">
                                        Tú
                                      </span>
                                    )}
                                  </td>
                                  <td>{user.properties_list.length}</td>
                                  <td>
                                    <span
                                      className={`badge ${
                                        user.role_name || user.role?.name
                                          ? "badge-light-info"
                                          : "badge-light"
                                      }`}
                                    >
                                      {user.role_name ||
                                        user.role?.name ||
                                        "N/D"}
                                    </span>
                                  </td>
                                  <td>
                                    {/* 👉 No mostrar acciones si es el propio usuario */}
                                    {!isSelf ? (
                                      <TableActions
                                        user={user}
                                        fetchData={fetchData}
                                      />
                                    ) : null}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start"></div>
                        <div className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end">
                          <div
                            className="dataTables_paginate paging_simple_numbers"
                            id="kt_table_users_paginate"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {usersListontext.showNewUserModal && (
        <ModalNewUser onClose={() => usersListontext.closeNewUserModal()} />
      )}
      {usersListontext.showChangeUserPropertiesModal && (
        <ModalChangeUserProperties
          onClose={() => usersListontext.closeChangeUserPropertiesModal()}
          user={usersListontext.selectedUser}
        />
      )}

      {usersListontext.showChangeUserRoleModal && (
        <ModalChangeUserRole
          onClose={() => usersListontext.closeChangeUserRoleModal()}
          user={usersListontext.selectedUser}
        />
      )}
    </>
  );
};

const TableActions = ({ user, fetchData }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const menuRef = useRef(null);
  const anchorRef = useRef(null);
  const usersListontext = useAdminUsersListContext();

  const toggleDropdown = () => {
    setShowMenu(!showMenu);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  useEffect(() => {
    if (showMenu) {
      // Obtenemos las coordenadas del elemento anchor
      const anchorRect = anchorRef.current.getBoundingClientRect();
      const elementWidth = anchorRef.current.offsetWidth;
      // Calculamos la posición del menú
      const screenWidth = window.innerWidth;
      const menuX = anchorRect.left - screenWidth + elementWidth;
      const menuY = anchorRect.top + anchorRect.height + 10;
      setMenuPosition({ x: menuX, y: menuY });
    }
  }, [showMenu]);

  return (
    <>
      <a
        className="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary show menu-dropdown"
        onClick={toggleDropdown}
        ref={anchorRef}
        title="Acciones"
      >
        Acciones
        <i className="ki-outline ki-down text-color-azul-wofyrooms fs-5 ms-1"></i>
      </a>

      <div
        ref={menuRef}
        style={{
          transform: `translate3d(${menuPosition.x}px, ${menuPosition.y}px, 0)`,
        }}
        className={`menu-actions-table menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4 ${
          showMenu ? "show" : ""
        }`}
      >
        <div className="menu-item px-3">
          <a
            className="menu-link px-3"
            onClick={() => usersListontext.openChangeUserPropertiesModal(user)}
          >
            Editar Propiedades
          </a>
        </div>

        <div className="menu-item px-3">
          <a
            className="menu-link px-3"
            onClick={() => usersListontext.openChangeUserRoleModal(user)}
          >
            Cambiar Rol
          </a>
        </div>

        <div className="menu-item px-3">
          <a
            className="menu-link px-3"
            onClick={() =>
              ModalDeactivateUser.handleDeactivate(
                user.id,
                fetchData,
                user.email
              )
            }
          >
            Desactivar usuario
          </a>
        </div>
      </div>
    </>
  );
};

export default AdminUsersListPage;
